import Yup from 'utils/validation/yup-extensions';
import { REGEX_EMAIL } from '../../../utils/strings/StringUtil';

export const CSS_CLASSES = {
	BODY_ADD: 'form__body--add',
	BODY_INFORMATIONAL_LABEL: 'form__body__label--informational',
	BODY_VERIFY: 'form__body--verify',
	CARD_CONFIRM: 'card--confirm',
	DIALOG_LIST: 'dialog__list',
	FORM_INPUT: 'form__input--text',
	FOOTER: 'form__footer',
	HIDDEN: 'hidden',
};

/**
 * Supported URL query parameter(s).
 * @type {Object}
 */
export const QUERY_PARAMS = {
	ACTION: 'ACTION',
	DESTINATION: 'DEST',
	MQ_ID: 'MQ',
	TRACKING_NUMBER: 'TN',
};

/**
 * Supported URL query parameter value(s) for {@link QUERY_PARAMS} 'ACTION' property.
 * @type {Object}
 */
export const ACTIONS = {
	SEARCH: 'SEARCH',
	ADD: 'ADD',
	ADD_LINK: 'ADD_LINK',
	VERIFY: 'VERIFY',
};

/**
 * Supported URL query parameter value(s) for {@link QUERY_PARAMS} 'DESTINATION' property.
 * @type {Object}
 */
export const DESTINATIONS = {
	NEW_IDENTITY: 'NEW_IDENTITY',
};

/**
 * Form property keys.
 * @type {Object}
 */
export const FORM_KEYS = {
	BUTTON_HOME: 'BUTTON_HOME',
	BUTTON_RESET: 'BUTTON_RESET',
	BUTTON_SUBMIT: 'BUTTON_SUBMIT',
	CHECKBOX_ACCEPTANCE: 'CHECKBOX_ACCEPTANCE',
	EXISTENCE_ACCEPTANCE: 'EXISTENCE_ACCEPTANCE',
	REQUESTOR: 'REQUESTOR_EMAIL',
	REPRESENTATIVE: 'REPRESENTATIVE_EMAIL',
	DOCUMENT_SELECTOR: 'DOCUMENT_SELECTOR',
};

/**
 * Default Formik form initial value object.
 * @type {Object}
 */
export let FORM_INITIAL_VALUES = {
	[ACTIONS.ADD]: {
		[FORM_KEYS.REQUESTOR]: '',
		[FORM_KEYS.REPRESENTATIVE]: '',
		[FORM_KEYS.DOCUMENT_SELECTOR]: '',
		[FORM_KEYS.CHECKBOX_ACCEPTANCE]: false,
	},
	[ACTIONS.VERIFY]: {
		[FORM_KEYS.EXISTENCE_ACCEPTANCE]: null,
	},
};

export const VALIDATION_MESSAGE = 'Field is required.';

/**
 * Default Formik form Yup validation schema logic object.
 * @type {Object}
 */
export const FORM_VALIDATION_SCHEMA_OBJECT = {
	[ACTIONS.ADD]: {
		[FORM_KEYS.REQUESTOR]: Yup.string()
			.matches(
				REGEX_EMAIL,
				'Please provide a valid email address format.'
			)
			.required(VALIDATION_MESSAGE),
		[FORM_KEYS.CHECKBOX_ACCEPTANCE]: Yup.boolean().oneOf(
			[true],
			VALIDATION_MESSAGE
		),
		[FORM_KEYS.REPRESENTATIVE]: Yup.string()
			.matches(
				REGEX_EMAIL,
				'Please provide a valid email address format.'
			)
			.required(VALIDATION_MESSAGE),
		[FORM_KEYS.DOCUMENT_SELECTOR]:
			Yup.string().required(VALIDATION_MESSAGE),
	},
	[ACTIONS.VERIFY]: {
		[FORM_KEYS.EXISTENCE_ACCEPTANCE]: Yup.mixed()
			.nullable()
			.oneOf(['true', 'false'], VALIDATION_MESSAGE)
			.required(VALIDATION_MESSAGE),
	},
};
